import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Radio, RadioGroup, FormControlLabel, FormControl, FormLabel} from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: '20px',
        height: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#fff',
        backgroundImage: '#fff',
        '$root.Mui-focusVisible &': {
            outline: '1px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#fff',
        borderRadius: '50%',
        border: '1px solid #2057AD',
        width: 18,
        height: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#2057AD',
        '&:before': {
            content: '""',
            display: 'block',
            width: 12,
            height: 12,
            borderRadius: '50%',
            backgroundColor: '#2057AD',
        },
        'input:hover ~ &': {
            backgroundColor: '#fff',
        },
    },
    promptText: {
        fontFamily: 'Hind',
        fontSize: '16px',
        fontWeight: 500,
        color: '#28282E',
        paddingBottom:'10px',
    },
    promptTextLabel: {
        fontFamily: 'Hind',
        fontSize: '16px',
        fontWeight: 400,
        color: '#28282E',
    },
    radioColorPrimary: {
        '&.Mui-checked': { color: '#2057AD' },
        paddingTop: 0,
        paddingBottom: 0,
    },
});


export default function CustomizedRadios({data, handleRemoveUserFromStudy, ...props}) {
    const handleChange = (event) => {
        const { value } = event.target;
        const booleanValue = value === 'yes' ? true : false;
        handleRemoveUserFromStudy(booleanValue);
    };
    const classes = useStyles();
    return (
        <FormControl component="fieldset">
            <FormLabel component="legend" className={classes.promptText} style={{ color: '#28282E' }}>
                Would you like to also remove {data.delegationName}’s Study access?
            </FormLabel>
            <RadioGroup onChange={handleChange} aria-label="remover" name="remover">
                <FormControlLabel value="yes" control={<Radio color="primary" className={classes.radioColorPrimary} required />} label={<span className={classes.promptTextLabel}>Yes</span>} />
                <FormControlLabel value="no" control={<Radio color="primary" required className={classes.radioColorPrimary} />} label={<span className={classes.promptTextLabel}>No</span>} />
            </RadioGroup>
        </FormControl>
    );
}